import React from "react"
type NodeProps = {
  children: React.ReactNode
}

export const Bold = ({ children }: NodeProps) => <strong>{children}</strong>

export const Text = ({ children }: NodeProps) => (
  <p style={{ fontSize: "16px"  }}>{children}</p>
)

export const Heading1 = ({ children }: NodeProps) => (
  <h1 style={{ fontSize: "36px" }}>{children}</h1>
)

export const Heading2 = ({ children }: NodeProps) => (
  <h2 style={{fontSize: '1.75rem',
    marginBottom: '20px',
    fontWeight: '600',
    lineHeight: '1.3',
    marginTop: '40px'}}>{children}</h2>
)